import Main from '@/components/main';

export default {
    path: '/sale-management',
    name: 'sale-management',
    meta: {
        icon: 'ios-archive',
        title: '销售管理',
        showAlways: true
    },
    component: Main,
    children: [
        {
            path: 'sale-list',
            name: 'sale-list',
            meta: {
                icon: 'ios-archive',
                title: '购物车',
                notCache: false,
                access: ['B', 'C', 'S', 'G', 'J', 'P'],
                items: [
                ]
            },
            component: () => import('@/view/sale-management/sale-list/sale-list')
        },
        {
		    path: 'intention-list',
		    name: 'intention-list',
		    meta: {
		        icon: 'ios-archive',
		        title: '意向单',
		        notCache: false,
		        access: ['B', 'C', 'S', 'G', 'J', 'P'],
		        items: [
		        ]
		    },
		    component: () => import('@/view/preSale-management/intention-order')
        },
        {
		    path: 'preSale-wait-pay',
		    name: 'preSale-wait-pay',
		    meta: {
		        icon: 'ios-archive',
		        title: '待支付定单',
		        notCache: false,
		        access: ['B', 'C', 'S', 'G', 'J', 'P'],
		        items: [
		        ]
		    },
		    component: () => import('@/view/preSale-management/preSale-wait-pay')
        },

        {
		    path: 'deposit-list',
		    name: 'deposit-list',
		    meta: {
		        icon: 'ios-archive',
		        title: '定金单',
		        notCache: false,
		        access: ['B', 'C', 'S', 'G', 'J', 'P'],
		        items: [
		        ]
		    },
		    component: () => import('@/view/sale-management/deposit-list/deposit-list')
        },
        {
		    path: 'liquidated-damage-list',
		    name: 'liquidated-damage-list',
		    meta: {
		        icon: 'ios-archive',
		        title: '违约单',
		        notCache: false,
		        access: ['B', 'C', 'S', 'G', 'J', 'P'],
		        items: [
		        ]
		    },
		    component: () => import('@/view/preSale-management/liquidated-damage/liquidated-damage')
        },
        {
		    path: 'deliveryList',
		    name: 'deliveryList',
		    meta: {
		        icon: 'ios-archive',
		        title: '发货单',
		        notCache: false,
		        access: ['B', 'C', 'S', 'G', 'A', 'I', 'I2', 'D', 'J', 'P'],
		        items: [
		        ]
		    },
		    component: () => import('@/view/sale-management/delivery-list/delivery-list')
        },
        /*{
		    path: 'returnOrder',
		    name: 'returnOrder',
		    meta: {
		        icon: 'ios-archive',
		        title: '退货单',
		        notCache: false,
		        access: ['B', 'C', 'S', 'G', 'A', 'I', 'I2', 'D','J','P'],
		        items: [
		        ]
		    },
		    component: () => import('@/view/sale-management/return-order/return-order')
		},*/
        // {
        //     path: 'distributionStation-delivery-check',
        //     name: 'distributionStation-delivery-check',
        //     meta: {
        //         icon: 'ios-archive',
        //         title: '发货单质检',
        //         notCache: true,
        //         access: ['D', 'S', 'I', 'I2'],
        //         items: [
        //         ]
        //     },
        //     component: () => import('@/view/distributionStation-management/distributionStation-delivery-check/distributionStation-delivery-check')
        // },
        // {
        //     path: 'DistributionDeliveryList',
        //     name: 'DistributionDeliveryList',
        //     meta: {
        //         icon: 'ios-archive',
        //         title: '配送单',
        //         notCache: false,
        //         access: ['D', 'S', 'I', 'I2', 'B', 'C'],
        //         items: [
        //         ]
        //     },
        //     component: () => import('@/view/sale-management/delivery-list/distribution-delivery-list')
        // },
        // {
        //     path: 'sale-station-compensation-list',
        //     name: 'sale-station-compensation-list',
        //     meta: {
        //         icon: 'ios-archive',
        //         title: '售后退款',
        //         notCache: true,
        //         access: ['I', 'S'],
        //         items: [
        //         ]
        //     },
        //     component: () => import('@/view/sale-management/compensation/station-compensation-list')
        // },
        {
            path: 'complain-list',
            name: 'complain-list',
            meta: {
                icon: 'ios-archive',
                title: '售后列表',
                notCache: true,
                access: ['I', 'I2', 'S', 'B', 'C', 'G', 'D', 'J', 'P'],
                items: [
                ]
            },
            component: () => import('@/view/sale-management/complain/complain-list')
        },
        {
            path: 'sale-compensation-list',
            name: 'sale-compensation-list',
            meta: {
                icon: 'ios-archive',
                title: '退款单',
                notCache: false,
                access: ['I', 'I2', 'S', 'B', 'C', 'G', 'D', 'J', 'P'],
                items: [
                ]
            },
            component: () => import('@/view/sale-management/compensation/compensation-list')
        },
        {
            path:'logistics-information',
            name:'logistics-information',
            meta:{
                icon:'ios-archive',
                title:'物流信息',
                notCache:false,
                access: ['I', 'I2', 'S', 'B', 'C', 'G', 'D', 'P'],
                items: [
                ]
            },
            component:()=> import('@/view/sale-management/logistics-information/logistics-information-list')
        }/* ,
        {
            path: 'sale_deposit_stat_list',
            name: 'sale_deposit_stat_list',
            meta: {
                icon: 'ios-archive',
                title: '销售统计(定金单)',
                notCache: false,
                access: ['S', 'A', 'B', 'C', 'D', 'I', 'I2', 'G'],
                items: [
                ]
            },
            component: () => import('@/view/sale-management/sale-stat/sale_deposit_stat_list')
        } */,
        {
            path: 'sale-stat-list',
            name: 'sale-stat-list',
            meta: {
                icon: 'ios-archive',
                title: '销售统计(发货单)',
                notCache: false,
                access: ['S', 'A', 'B', 'C', 'D', 'I', 'I2', 'G', 'J', 'P'],
                items: [
                ]
            },
            component: () => import('@/view/sale-management/sale-stat/sale-stat-list')
        },
        {
		    path: 'deposit-sale-stat-list',
		    name: 'deposit-sale-stat-list',
		    meta: {
		        icon: 'ios-archive',
		        title: '销售统计(定金单)',
		        notCache: false,
		        access: ['S', 'A', 'B', 'C', 'D', 'I', 'I2', 'G', 'J', 'P'],
		        items: [
		        ]
		    },
		    component: () => import('@/view/sale-management/sale-stat/deposit-sale-stat-list')
        },
        {
		    path: 'sale-help-order',
		    name: 'sale-management-sale-help-order',
		    meta: {
		        icon: 'ios-archive',
		        title: '代下单',
		        notCache: false,
		        access: ['G'],
		        items: [
		        ]
		    },
		    component: () => import('@/view/sale-management/sale-help-put-cart/sale-help-put-cart')
        },
        {
		    path: 'abandoned-deposit-list',
		    name: 'abandoned-deposit-list',
		    meta: {
		        icon: 'ios-archive',
		        title: '定金单废单',
		        notCache: false,
		        access: ['B', 'C', 'S', 'G', 'P'],
		        items: [
		        ]
		    },
		    component: () => import('@/view/sale-management/abandoned/abandoned-deposit-list')
        },
        {
		    path: 'deliveryRevokeRecords',
		    name: 'deliveryRevokeRecords',
		    meta: {
		        icon: 'ios-archive',
		        title: '发货单废单',
		        notCache: false,
		        access: ['B', 'C', 'S', 'G', 'A', 'I', 'I2', 'D', 'P'],
		        items: [
		        ]
		    },
		    component: () => import('@/view/preSale-management/delivery-revoke-records/delivery-revoke-records')
        },
        {
		    path: 'PatentFeeManagement',
		    name: 'PatentFeeManagement',
		    meta: {
		        icon: 'ios-archive',
		        title: '专利费',
		        notCache: false,
		        access: ['B', 'S'],
		        items: [
		        ]
		    },
		    component: () => import('@/view/sale-management/patent-fee/patent-fee.vue')
        }
        /* {
		    path: 'refund-request-list',
		    name: 'refund-request-list',
		    meta: {
		        icon: 'ios-archive',
		        title: '退款申请表',
		        notCache: false,
		        access: ['B', 'G'],
		        items: [
		        ]
		    },
		    component: () => import('@/view/sale-management/refund-request/refund-request-list')
		} */
    ]
};
